import * as React from 'react'
import { FC } from 'react'
import ReceiptPosition from '../../../../../../../../../types/api/receipt-position'
import { Table } from 'antd/lib'
import { EditableCell } from '../../../../../../../../../components/editable-cell/editable-cell'
import { ColumnType } from 'antd/lib/table'
import _, { set } from 'lodash'
import { useUpdateReceiptPositionMutation } from '../../../../../../../../../store/api/receipt-positions-api'
import { useLazyGetReceiptByDocIdQuery } from '../../../../../../../../../store/api/receipts-api'
import { EndpointQueryParameters } from '../../../../../../../../../types/strapi/strapi'
import EditNumber from './components/edit-number'
import { setEditing } from './helpers/table-helpers'
import formatIntegerBySpace from '../../../../../../../../../helpers/formatters/format-integer-by-space'

interface ColumnGroupType<ReceiptPosition = {}>
    extends Omit<ColumnType<ReceiptPosition>, 'dataIndex'> {
    children: (
        | (ColumnType<ReceiptPosition> & { editable?: boolean; FormItem?: React.ReactNode })
        | ColumnGroupType
    )[]
}

export const columns: (
    | (ColumnType<any> & { editable?: boolean; FormItem?: React.ReactNode })
    | ColumnGroupType<any>
)[] = [
    {
        title: 'Материал',
        dataIndex: ['material', 'material_type', 'name'],
        width: 100,
    },
    {
        title: 'Ширина',
        dataIndex: ['material', 'width'],
        render: (v: number) => formatIntegerBySpace(v),
    },
    {
        title: 'Ининциатор',
        dataIndex: ['initiator', 'username'],
        minWidth: 150,
    },
    {
        title: 'Кол-во',
        dataIndex: 'amount',
        width: 100,
        editable: true,
        render: (v: number) => formatIntegerBySpace(v),
        FormItem: <EditNumber namePath={'amount'} />,
    },
    {
        title: 'Ед.измер.',
        dataIndex: ['unit', 'shortName'],
        minWidth: 50,
    },
]

interface ReceiptPositionEditProps {
    dataSource?: ReceiptPosition[]
    receiptQueryParams: EndpointQueryParameters
    receiptId: string
}

const ReceiptPositionEdit: FC<ReceiptPositionEditProps> = ({
    dataSource,
    receiptQueryParams,
    receiptId,
}) => {
    const [getReceiptByDocId] = useLazyGetReceiptByDocIdQuery()
    const [updateReceiptPosition] = useUpdateReceiptPositionMutation()

    const onSave = async (
        record: ReceiptPosition,
        [name, value]: [string, string | number | string[]]
    ) => {
        try {
            const data = {}
            set(data, name, value)
            const res = await updateReceiptPosition({
                docId: record.documentId,
                body: { data },
            })
            if (res.data) {
                getReceiptByDocId([receiptId, receiptQueryParams])
            }
        } catch (e) {
            console.error(e)
        }
    }

    let columnsForRender = setEditing(columns, onSave)
    const dataSourceSort = dataSource
        ? _.cloneDeep(dataSource).sort((a, b) =>
              a.material.material_type.name > b.material.material_type.name ? 1 : -1
          )
        : []
    return (
        <Table
            key={'tableEdit'}
            bordered
            columns={columnsForRender}
            dataSource={dataSourceSort}
            components={{ body: { cell: EditableCell } }}
            rowKey={x => x.documentId}
        />
    )
}

export default ReceiptPositionEdit
